import { useDispatch } from "react-redux";
import MasterLayout from "../otherImages/MasterLayout";
import DefaultTopBar from "../components/DefaultTopBar";
import OrdersDataTable from "../components/OrdersDataTable";
import { exportOrders } from "../Redux/Reducers/ProductSlice";
import useTableUrlState from "../hook/useTableUrlState";

const ManageInvoices = () => {
  const dispatch = useDispatch();
  const [{ statusFilter }, setTableState] = useTableUrlState({
    statusFilter: "all",
  });

  const handleExportOrders = () => {
    console.log("EXPORT ORDERS CLICKED:", { status: statusFilter });
    dispatch(exportOrders({ status: statusFilter }));
  };

  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        <DefaultTopBar
            title="Manage Orders"
            btnText="Export File"
            btnOnClick={handleExportOrders}
        />

        {/* TableDataLayer */}
        <OrdersDataTable
          statusFilter={statusFilter}
          setStatusFilter={(value) => setTableState({ statusFilter: value, page: 0 })}
        />

      </MasterLayout>

    </>
  );
};

export default ManageInvoices; 
